// extracted by mini-css-extract-plugin
module.exports = {"index":"HeadlinePoint_index__z8wVp","noMargin":"HeadlinePoint_noMargin__3t_47"};